
import { Component, Prop, Vue } from "vue-property-decorator";

import Notice from "@/domain/restaurant/Notice";

@Component
export default class NoticeCard extends Vue {
  @Prop({ default: null })
  notice!: Notice | null;

  @Prop()
  loading!: boolean;

  noticeColourToDisplay(notice: Notice) {
    if (notice === null || this.loading) return "";
    return Notice.getNoticeTypeFromString(this.notice!.type)?.colour;
  }

  noticeIconToDisplay(notice: Notice) {
    return Notice.getNoticeTypeFromString(this.notice!.type)?.icon?.icon;
  }

  noticeTypeToDisplay(notice: Notice) {
    return Notice.getNoticeTypeFromString(this.notice!.type)?.text;
  }

  get cardHeight() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return "120pt";
      case "sm":
        return "120pt";
      case "md":
        return "60pt";
      case "lg":
        return "60pt";
      case "xl":
        return "60pt";
    }
  }

  get truncatedMessage() {
    if (this.notice === null || this.notice.message == null) return "";
    return (
      this.notice?.message.slice(0, 80) +
      (this.notice?.message.length > 80 ? " (...)" : "")
    );
  }

  async showNoticeDialog() {
    if (this.$store.getters.isManager) this.$emit("showNoticeDialog");
  }
}
